import { combineReducers } from 'redux'
import * as types from './types'

const initialState = {
  userInfo: {},
}
const userInfoReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CHANGE_USERINFO:
      return {
        ...state,
        userInfo: payload
      }
    default:
      return state
  }
}

// COMBINED REDUCERS
const reducers = {
  userInfo: userInfoReducer,
}

export default combineReducers(reducers)